import React from "react";
import "../Styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2025 Pravartan. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
